import { TypeToConverterSet, ConverterSet } from './domain.js';

export function typeToConverterSet(
  converterSets: ConverterSet[],
): TypeToConverterSet {
  return converterSets.reduce((result, converterSet) => {
    const types = converterSet.types.reduce((typeResult, type) => {
      return {
        ...typeResult,
        [type]: converterSet,
      };
    }, {} as TypeToConverterSet);

    return {
      ...result,
      ...types,
    };
  }, {} as TypeToConverterSet);
}
